// ============================================
// Auth - State (Zustand 기반)
// ============================================

import { useAuthStore } from '../../stores/authStore.js';

// ============================================
// Firebase Auth/Storage (로컬 참조 유지)
// Firebase 인스턴스는 Zustand와 별도로 관리
// ============================================

let auth = null;
let storage = null;
let authDb = null;

export function getAuth() {
  return auth;
}

export function setAuth(authInstance) {
  auth = authInstance;
  useAuthStore.getState().setAuth(authInstance);
}

export function getStorage() {
  return storage;
}

export function setStorage(storageInstance) {
  storage = storageInstance;
  useAuthStore.getState().setStorage(storageInstance);
}

export function getAuthDb() {
  if (!authDb) authDb = firebase.firestore();
  useAuthStore.getState().setDb(authDb);
  return authDb;
}

// ============================================
// Current User (Zustand 사용)
// ============================================

export function getCurrentUser() {
  return useAuthStore.getState().currentUser;
}

export function setCurrentUser(user) {
  useAuthStore.getState().setCurrentUser(user);
}

// ============================================
// User Carbon (Zustand 사용)
// ============================================

export function getUserCarbon() {
  return useAuthStore.getState().userCarbon;
}

export function setUserCarbon(value) {
  useAuthStore.getState().setUserCarbon(value);
}

// ============================================
// User Nickname (Zustand 사용)
// ============================================

export function getUserNickname() {
  return useAuthStore.getState().userNickname;
}

export function setUserNickname(nickname) {
  useAuthStore.getState().setUserNickname(nickname);
}

// ============================================
// Cached Profiles (Zustand 사용)
// ============================================

export function getCachedProfiles() {
  return useAuthStore.getState().cachedProfiles;
}

export function setCachedProfiles(profiles) {
  useAuthStore.getState().setCachedProfiles(profiles);
}

export function getCachedPrimaryProfileId() {
  return useAuthStore.getState().cachedPrimaryProfileId;
}

export function setCachedPrimaryProfileId(profileId) {
  useAuthStore.getState().setCachedPrimaryProfileId(profileId);
}

export function getPrimaryProfile() {
  return useAuthStore.getState().getPrimaryProfile();
}

// ============================================
// Admin Status (로컬 상태)
// ============================================

let isAdmin = false;

export function getIsAdmin() {
  return isAdmin;
}

export function setIsAdmin(value) {
  isAdmin = value;
}
